
import { APPSTORE_LINK, PLAYSTORE_LINK } from '../utils/ConstLinks';

export const DownloadAppLinks = (): JSX.Element => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginTop: 32,
        marginBottom: 32,
      }}
    >
      <a
        href={APPSTORE_LINK}
        style={{
          display: 'block',
          borderRadius: '13px',
        }}
      >
        <img
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1597017600&h=11525252353c324d7ab768ac3ff51942"
          alt="Download on the App Store"
          style={{ borderRadius: '13px', width: '250px', height: '83px' }}
        />
      </a>

      <a href={PLAYSTORE_LINK} style={{ display: 'block' }}>
        <img
          style={{ height: 123 }}
          alt="Get it on Google Play"
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
        />
      </a>
    </div>
  );
};
